import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import { RISK_LOWER_THRESHOLD, RISK_UPPER_THRESHOLD } from '@/constants/risks';
import { GetRiskAnalysisByCancerTypeResponse } from '@/repositories/risk.repository';
import { RiskAnalysisChart } from '../../../common/risk-analysis-chart/risk-analysis-chart';
import RiskAnalysisCard from './components/risk-analysis-card/risk-analysis-card';
import RiskAnalysisSummary from './components/risk-analysis-summary/risk-analysis-summary';
import RiskAnalysisTitle from './components/risk-analysis-title/risk-analysis-title';
import { Box } from '@cmpsr/components';

type RiskAnalysisHeaderProps = {
  data: GetRiskAnalysisByCancerTypeResponse;
};

export default function RiskAnalysisHeader(props: RiskAnalysisHeaderProps) {
  const riskBadgeStyle = _getRiskBadgeStyle(props.data.lifetime.current, props.data.lifetime.average);

  return (
    <Box data-testid="risk-analysis-header">
      <DashboardLayout
        containerProps={{
          // Theses custom paddings are to have the main title
          // and subtitle at the same level in every page
          pt: { base: 14, md: 14, lg: 16 },
          pb: { base: 8, md: 10, lg: 14 },
          background: 'gradient.dark',
        }}
        contentProps={{ as: 'header' }}
      >
        <RiskAnalysisTitle />

        <RiskAnalysisSummary bgColor={riskBadgeStyle.bgColor} color={riskBadgeStyle.color} text={riskBadgeStyle.text} />

        <DashboardGrid gap={{ base: 5, lg: 8, xl: 9, xxl: 12 }}>
          <RiskAnalysisChart currentRiskColor={riskBadgeStyle.bgColor} data={props.data.risks} />

          <RiskAnalysisCard
            currentRisk={props.data.lifetime.current}
            potentialRisk={props.data.lifetime.optimal}
            averageRisk={props.data.lifetime.average}
            badgeStyle={riskBadgeStyle}
          />
        </DashboardGrid>
      </DashboardLayout>
    </Box>
  );
}

function _getRiskBadgeStyle(currentRisk: number, averageRisk: number) {
  if (currentRisk > averageRisk * RISK_UPPER_THRESHOLD) {
    return {
      bgColor: 'var(--chakra-colors-alert-error-default)',
      color: 'var(--chakra-colors-text-error)',
      text: 'Above Average Risk',
    };
  } else if (currentRisk < averageRisk * RISK_LOWER_THRESHOLD) {
    return {
      bgColor: 'var(--chakra-colors-alert-success-default)',
      color: 'var(--chakra-colors-text-success)',
      text: 'Below Average Risk',
    };
  } else {
    return {
      bgColor: 'var(--chakra-colors-alert-warning-default)',
      color: 'var(--chakra-colors-text-warning)',
      text: 'Average Risk',
    };
  }
}
